import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { RoleGuard } from "app/guards";
import { CorreosElectronicosTable } from "./correos-electronicos-table";
import { CorreoElectronicoForm } from "./correo-electronico-form";
import { CorreosElectronicosProvider } from "./correos-electronicos-context";

export function CorreosElectronicosRoutes() {
  return (
    <RoleGuard roles={["empresa:correos-electronicos"]}>
      <CorreosElectronicosProvider>
        <Routes>
          <Route path="/" element={<Outlet />}>
            <Route index element={<CorreosElectronicosTable />} />

            <Route path="add" element={<CorreoElectronicoForm />} />

            <Route path=":correo_electronico_id" element={<Outlet />}>
              <Route index element={<Navigate to="edit" replace />} />

              <Route path="edit" element={<CorreoElectronicoForm />} />
            </Route>

            <Route path="*" element="CorreosElectronicos: Page Not Found" />
          </Route>
        </Routes>
      </CorreosElectronicosProvider>
    </RoleGuard>
  );
}
